module.exports = __webpack_public_path__ + "svg/flags/Saint Vincent and the Grenadines.svg";